import { throttle, debounce }  from 'throttle-debounce'

const createOnScrollMixin = (listener, options = { debounce: 0, throttle: 0 }) => {
  const namespace = Symbol('namespace')
  return {
    created () {
      if (options.debounce) {
        this[namespace] = debounce(options.debounce, listener.bind(this))
      } else if (options.throttle) {
        this[namespace] = throttle(options.throttle, listener.bind(this))
      } else {
        this[namespace] = listener.bind(this)
      }
      window.addEventListener('scroll', this[namespace])
    },
    destroyed () {
      window.removeEventListener('scroll', this[namespace])
    },
  }
}

export default createOnScrollMixin
